import React, { Component } from 'react';
import store from "store/store";
import Joi from "joi-browser";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as auth from "store/auth/user/action";

class ForgotPassword extends Component {
    state = { 
        forgotPasswordForm: {
            email: "",
        },
        errors: {}
    }

    formChange = (e) => {
        const formValue = {...this.state.forgotPasswordForm};
        formValue[e.currentTarget.name] = e.currentTarget.value;
        this.setState({forgotPasswordForm: formValue});
    }
    
    schema = {
        email: Joi.string().email().required().label("Email Address").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter your email address";
                        break;
                    case "string.email":
                        err.message = "Please enter your valid email address";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
    }

    validate = () => {
        const options = { abortEarly: false };
        const result = Joi.validate(this.state.forgotPasswordForm, this.schema, options);
        // console.log(result);
        const error = result.error;
        if (!error) return null;
    
        const errors = {};
        for (let item of result.error.details){
            errors[item.path[0]] = item.message;
        }
        return errors;
    };

    submitForm = (e) => {
        e.preventDefault();
        const errors = this.validate();
        this.setState({errors: errors || {}});
        if (errors){
            // console.log(errors);
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            // alert('all good');
            // console.log(this.state.forgotPasswordForm);
            this.props.forgotPassword(this.state.forgotPasswordForm);
        }
    }

    componentDidMount() {
        this.unsubscribe = store.subscribe(() => {
            if (store.getState().auth.user.forgotPassword === true){
                this.props.history.push("/reset-password");
                this.props.resetForgotPassword();
            }
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }
    

    render() { 
        const {forgotPasswordForm} = this.state;

        return (
            
            <>
                <div className="mt-10 text-center">
                    <div className="font-semibold text-2xl sm:text-3xl 2xl:text-4xl font-recoleta">
                        Forgot Password
                    </div>
                    <div className="hidden mt-1">
                        Enter your login email address
                    </div>
                </div>

                <div className="max-w-md mx-auto p-8 mt-10 bg-white rounded">
                    <form onSubmit={this.submitForm}>

                        <div>
                            
                            <div className="form-group">
                                <label>
                                    Email Address
                                    <span className="form-input-required">*</span>
                                </label>
                                <input type="email" name="email" placeholder="example@email.com" className="form-input" value={forgotPasswordForm.email} onChange={this.formChange} />
                            </div>

                            <button type="submit" className="btn btn-lg btn-block btn-ep-blue mt-8" disabled={this.props.loading}>
                                <FontAwesomeIcon icon="spinner" spin className={"text-xl mr-2 " + (this.props.loading?"inline":"hidden")} />
                                Reset Password
                            </button>

                            <div className="mt-3 text-sm font-semibold text-gray-500">
                                Remember your password? &nbsp;
                                <Link to="/login" className="text-ep-blue hover:underline">Login</Link>
                            </div>

                        </div>

                    </form>
                </div>
            </>
        )
    }
}
 


const mapStateToProps = (state) => ({
    loading: state.auth.user.loading,
    forgotPassword: state.auth.user.forgotPassword,
});

const mapDispatchToProps = (dispatch) => ({
    forgotPassword: (params) => dispatch(auth.forgotPassword(params)),
    resetForgotPassword: () => dispatch(auth.resetForgotPassword()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);